import moment from 'moment/moment';
import customDayTemplatesModel from '$$customDayTemplatesModel';
import globalStore from '$$globalStore';

export default function (instance, projectId) {
  const createDayStartedAt00 = date => instance.date.day_start(moment(date).toDate());

  const setWorkTimeByDate = (calendar, dayFrom, dayTo, dayHours) => {
    if (!dayHours) {
      dayHours = false;
    }

    if (!dayTo) {
      // if single date
      calendar.setWorkTime({ date: dayFrom, hours: dayHours });
      instance.setWorkTime({ date: dayFrom, hours: dayHours });
    } else {
      // if repeatable
      while (dayFrom.valueOf() <= dayTo.valueOf()) {
        calendar.setWorkTime({ date: dayFrom, hours: dayHours });
        instance.setWorkTime({ date: dayFrom, hours: dayHours });
        dayFrom.setDate(dayFrom.getDate() + 1);
      }
    }
  };

  const calendar = instance.getCalendar(projectId);
  const projectTotalEstimate = globalStore.getters['tasksModel/getTotalEstimateDataForProject'](projectId);
  const customDays = customDayTemplatesModel.setAndGetCustomDaysForProject(projectId);

  let stepDay = {};
  let tempDate = {};
  let tempDateTo = {};
  const datesPeriod = {
    maxDate: projectTotalEstimate.end_date,
    minDate: projectTotalEstimate.start_date,
  };
  let tempEndDate = {};

  // set repeat days
  customDays.repeat.forEach(repeatDayData => {
    if (!repeatDayData.hours || !repeatDayData.hours.length) {
      // if weekend
      repeatDayData.hours = false;
    }

    switch (repeatDayData.repeat) {
    case 'week':
      stepDay = createDayStartedAt00(repeatDayData.from);

      tempEndDate = repeatDayData.repeat_to ? createDayStartedAt00(repeatDayData.repeat_to) : datesPeriod.maxDate;
      tempDateTo = createDayStartedAt00(repeatDayData.to);

      while (stepDay.valueOf() <= tempEndDate.valueOf()) {
        setWorkTimeByDate(
          calendar,
          new Date(stepDay),
          repeatDayData.to ? tempDateTo : null,
          repeatDayData.hours,
        );

        stepDay.setDate(stepDay.getDate() + 7);
      }

      break;
    case 'month':
      tempDate = createDayStartedAt00(repeatDayData.from).getDate();

      tempDateTo = createDayStartedAt00(repeatDayData.to).getDate();
      stepDay = createDayStartedAt00(repeatDayData.from);
      tempEndDate = repeatDayData.repeat_to ? createDayStartedAt00(repeatDayData.repeat_to) : datesPeriod.maxDate;

      while (stepDay.valueOf() <= tempEndDate.valueOf()) {
        setWorkTimeByDate(
          calendar,
          new Date(stepDay.getFullYear(), stepDay.getMonth(), tempDate),
          repeatDayData.to ? new Date(stepDay.getFullYear(), stepDay.getMonth(), tempDate) : null,
          repeatDayData.hours,
        );

        stepDay.setMonth(stepDay.getMonth() + 1);
      }
      break;
    case 'year':
      tempDate = createDayStartedAt00(repeatDayData.from);
      tempDateTo = createDayStartedAt00(repeatDayData.to);
      stepDay = createDayStartedAt00(repeatDayData.from);

      tempEndDate = repeatDayData.repeat_to
        ? createDayStartedAt00(repeatDayData.repeat_to)
        : datesPeriod.maxDate;

      while (stepDay.valueOf() <= tempEndDate.valueOf()) {
        setWorkTimeByDate(
          calendar,
          new Date(stepDay),
          repeatDayData.to
            ? createDayStartedAt00(repeatDayData.to)
            : null,
          repeatDayData.hours,
        );

        stepDay.setFullYear(stepDay.getFullYear() + 1);
      }
      break;
    }
  });

  customDays.exception.forEach(customDayData => {
    if (!customDayData.from && !customDayData.to) {
      return false;
    }

    if (!customDayData.hours || !customDayData.hours.length) {
      // if weekend
      customDayData.hours = false;
    }
    setWorkTimeByDate(
      calendar,
      createDayStartedAt00(customDayData.from),
      customDayData.to
        ? createDayStartedAt00(customDayData.to)
        : null,
      customDayData.hours,
    );
  });

  return instance;
}
